import { ChangeDetectorRef, Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AnametaOneRegisterModel } from '../../core/models/Register/anameta-one-register.model';
import { AuthService } from '../../core/services/auth.service';
import { EnmProfileTypes } from '../../core/models/enums/EnmProfileTypes.enum';
import { EnmAccountType } from '../../core/models/enums/EnmAccountType.enum';
import { HomeService } from '../../core/services/home.service';
import { PackageModel } from '../../core/models/packets/packet.model';
type ApplicantType = 'individual' | 'company';
type PaymentMethod = 'card' | 'transfer' | 'invoice';
type RegisterResult = 'success' | 'error' | null;


@Component({
    selector: 'app-register',
    standalone: false,
    templateUrl: './register.component.html',
    styleUrl: './register.component.css'
})
export class RegisterComponent {
    currentStep = 1;

    readonly wizardSteps = [{ id: 1, label: 'Paket Seçimi' }, { id: 2, label: 'Hesap Bilgileri' }, { id: 3, label: 'Onay' }];
    stepStatus: Record<number, 'pending' | 'success' | 'error'> = { 1: 'pending', 2: 'pending', 3: 'pending' };
    get stepTitle(): string { return this.currentStep === 1 ? (this.isCompany ? 'Şirketiniz için doğru paketi seçin' : 'Daha büyük fikirler için doğru paket') : this.currentStep === 2 ? (this.isCompany ? 'Şirket hesabınızı oluşturun' : 'Hesabınızı güvenle oluşturun') : this.loginErrorMessage ? 'Panelinize giriş yapın' : 'ANAMETA ONE’a hoş geldiniz'; }
    get stepDescription(): string { return this.currentStep === 1 ? (this.isCompany ? 'Ekibinizi, projelerinizi ve kurumsal servislerinizi tek platform üzerinden yönetin. İhtiyacınıza uygun kapasiteyi seçin.' : 'Projelerinizi bulutun gücüyle hayata geçirin. İhtiyacınıza en uygun paketi seçerek başlayın.') : this.currentStep === 2 ? (this.isCompany ? 'Firma adınızı, kurumsal e-posta adresinizi ve telefonunuzu girin. Şifrenizi ve güvenlik doğrulamasını tamamlayarak şirket hesabınızı oluşturun.' : 'Adınızı, e-posta adresinizi ve şifrenizi girin. Güvenlik doğrulamasını ve kullanım koşulları onayını tamamlayarak hesabınızı oluşturun.') : this.loginErrorMessage ? 'Hesabınız oluşturuldu. Giriş isteği tamamlanamadı; sağdaki mesajı kontrol edip yeniden deneyebilirsiniz.' : 'Hesabınız başarıyla oluşturuldu. Seçtiğiniz hesap ve paket bilgilerini kontrol ederek ANAMETA ONE paneline devam edin.'; }
    get stepFeatures(): string[] { return this.currentStep === 1 ? ['Global Altyapı', 'Yüksek Güvenlik', 'Esnek Ölçeklenebilirlik', '7/24 Destek'] : this.currentStep === 2 ? [this.isCompany ? 'Firma ve iletişim bilgileri' : 'Kişisel hesap bilgileri', 'En az 8 karakterli şifre', 'Güvenlik doğrulaması', 'Kullanım koşulları onayı'] : ['Hesap kaydı tamamlandı', 'Paket tercihiniz kaydedildi', 'Hesap özetini kontrol edin', 'Panelinize giriş yapın']; }
    getStepStatusText(step: number): string { return this.stepStatus[step] === 'success' ? 'Verify geçildi' : this.stepStatus[step] === 'error' ? 'Hata var · Kontrol edin' : this.currentStep === step ? 'Bu adımı tamamlayın' : 'Sıradaki adım'; }
    returnToAccount(): void { if (this.isSubmitting || this.isLoggingIn || this.registerResult === 'success') return; this.currentStep = 2; this.scrollToWizard(); }

    selectedApplicantType: ApplicantType = 'individual';
    selectedPackageId = '';
    formSubmitted = false;
    isSubmitting = false;
    isLoggingIn = false;
    registerResult: RegisterResult = null;
    registerErrorMessage = '';
    loginErrorMessage = '';
    registerToken = '';
    paymentMethod: PaymentMethod = 'card';
    readonly taxRate = 0.20;
    readonly applicationForm: FormGroup;
   
    packages: PackageModel[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private authService: AuthService,
        private cdr: ChangeDetectorRef,
        private homeSvc:HomeService
    ) {
        this.applicationForm = this.formBuilder.group({
            fullName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(180)]],
            email: ['', [Validators.required, Validators.email, Validators.maxLength(180)]],
            password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(100)]],
            passwordRepeat: ['', Validators.required],
            phone: [''],
            captcha: ['', Validators.required],
            consent: [false, Validators.requiredTrue]
        }, {
            validators: this.passwordMatchValidator
        });
        this.configurePhoneValidator();

        
        homeSvc.getPackets().subscribe((data)=> {

            if(data.isError) {

                alert(data.msg);

                router.navigateByUrl("/");
            }

            this.packages = data.data;

                             this.cdr.detectChanges();

        });
         

        this.setDummyData();
    }
    
    private setDummyData(): void {
    this.applicationForm.patchValue({
        fullName: 'Lerum Epsun',
        email: 'p2@anameta.com',
        password: 'testtest',
        passwordRepeat: 'testtest',
        phone: '5551234567',
        captcha: 'dummy-captcha',
        consent: true
    });

    this.applicationForm.markAllAsTouched();
    this.applicationForm.updateValueAndValidity();
}

    get filteredPackages(): PackageModel[] {
        const accountType = this.selectedApplicantType === 'company'
            ? EnmAccountType.Company
            : EnmAccountType.Individual;
        return this.packages.filter(x => x.accountType === accountType);
    }
    get selectedPackage(): PackageModel | undefined {
        return this.packages.find(x => x.id === this.selectedPackageId);
    }
    get selectedAccountType(): EnmAccountType {
        return this.selectedApplicantType === 'company'
            ? EnmAccountType.Company
            : EnmAccountType.Individual;
    }
    get selectedProfileType(): EnmProfileTypes {
        return this.selectedPackage?.profileType ?? EnmProfileTypes.None;
    }
    get isCompany(): boolean {
        return this.selectedApplicantType === 'company';
    }
    get packagePrice(): number {
        return this.selectedPackage?.monthlyPrice ?? 0;
    }
    get taxAmount(): number {
        return this.selectedPackage?.isCustomPrice ? 0 : this.packagePrice * this.taxRate;
    }
    get totalAmount(): number {
        return this.selectedPackage?.isCustomPrice ? 0 : this.packagePrice + this.taxAmount;
    }
    get fullNameLabel(): string {
        return this.isCompany
            ? 'Firma Adı / Ticari Ünvan'
            : 'Ad Soyad';
    }
    get fullNamePlaceholder(): string {
        return this.isCompany
            ? 'Firma adı veya ticari ünvan'
            : 'Adınızı ve soyadınızı girin';
    }
    selectApplicantType(type: ApplicantType): void {
        if (this.selectedApplicantType === type)
            return;
        this.stepStatus = { 1: 'pending', 2: 'pending', 3: 'pending' };
        this.registerResult = null;
        this.selectedApplicantType = type;
        this.selectedPackageId = '';
        this.formSubmitted = false;
        this.registerErrorMessage = '';
        if (type === 'individual' && this.paymentMethod === 'invoice')
            this.paymentMethod = 'card';
        this.configurePhoneValidator();
    }
    selectPackage(packageId: string): void {
        const packageItem = this.filteredPackages.find(x => x.id === packageId);
        if (!packageItem) { this.stepStatus[1] = 'error'; return; }
        this.stepStatus = { 1: 'success', 2: 'pending', 3: 'pending' };
        this.registerErrorMessage = '';
        this.registerResult = null;
        this.selectedPackageId = packageId;
        this.currentStep = 2;
        this.scrollToWizard();
    }
    previousStep(): void {
        if (this.isSubmitting || this.isLoggingIn)
            return;
        if (this.currentStep === 2) {
            this.currentStep = 1;
            this.scrollToWizard();
        }
    }
    submitRegistration(): void {
        if (this.isSubmitting)
            return;
        this.formSubmitted = true;
        this.registerErrorMessage = '';
        this.registerResult = null;
        if (!this.selectedPackage) {
            this.stepStatus[1] = 'error';
            this.currentStep = 1;
            this.scrollToWizard();
            return;
        }
        if (this.applicationForm.invalid) {
            this.stepStatus[2] = 'error';
            this.stepStatus[3] = 'pending';
            this.currentStep = 2;
            this.applicationForm.markAllAsTouched();
            return;
        }
        this.stepStatus[2] = 'pending';
        this.isSubmitting = true;
        const model = this.createRequestModel();
        this.authService.Register(model)
            .pipe(
                finalize(() => {
                    this.isSubmitting = false;
                    this.cdr.detectChanges();
                })
            )
            .subscribe({
                next: response => {
                    if (response.isError) {
                        this.showRegisterError(response.msg);
                        return;
                    }
                    this.registerToken = response.data?.accessToken ?? '';
                    this.stepStatus[2] = 'success';
                    this.stepStatus[3] = 'success';
                    this.registerResult = 'success';
                    this.currentStep = 3;
                    this.scrollToWizard();
                },
                error: error => {
                    this.showRegisterError(
                        error?.error?.msg ??
                        error?.message ??
                        'Kayıt işlemi sırasında bir hata oluştu.'
                    );
                }
            });
    }
    goToDashboard(): void {
        if (this.isLoggingIn || this.registerResult !== 'success') return;
        this.loginErrorMessage = '';
        const email = String(this.applicationForm.get('email')?.value ?? '').trim();
        const password = String(this.applicationForm.get('password')?.value ?? '');
        if (!email || !password) {
            this.stepStatus[3] = 'error';
            this.loginErrorMessage = 'Giriş bilgileri bulunamadı.';
            return;
        }
        this.isLoggingIn = true;
        this.authService.Login(email, password)
            .pipe(
                finalize(() => {
                    this.isLoggingIn = false;
                    this.cdr.detectChanges();
                })
            )
            .subscribe({
                next: response => {
                    if (response.isError) {
                        this.stepStatus[3] = 'error';
                        this.loginErrorMessage = response.msg ?? 'Giriş işlemi başarısız.';
                        return;
                    }
                    this.stepStatus[3] = 'success';
                    this.router.navigate(['/dashboard']);
                },
                error: error => {
                    this.stepStatus[3] = 'error';
                    this.loginErrorMessage =
                        error?.error?.msg ??
                        error?.message ??
                        'Giriş işlemi sırasında bir hata oluştu.';
                }
            });
    }
    createRequestModel(): AnametaOneRegisterModel {
        const value = this.applicationForm.getRawValue();
        return {
            lang: 'tr',
            accountType: this.selectedAccountType,
            profileType: this.selectedProfileType,
            email: String(value.email ?? '').trim(),
            password: String(value.password ?? ''),
            phone: this.isCompany ? String(value.phone ?? '').trim() : '',
            fullName: String(value.fullName ?? '').trim(),
            captcha: String(value.captcha ?? '')
        };
    }
    isInvalid(controlName: string): boolean {
        const control: AbstractControl | null = this.applicationForm.get(controlName);
        if (!control)
            return false;
        return control.invalid && (control.touched || this.formSubmitted);
    }
    setPaymentMethod(method: PaymentMethod): void {
        this.paymentMethod = method;
    }
    formatMoney(value: number): string {
        return new Intl.NumberFormat('tr-TR', {
            style: 'currency',
            currency: 'TRY',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(value);
    }
    formatLimit(value: number): string {
        if (value < 0)
            return 'Sınırsız';
        return new Intl.NumberFormat('tr-TR').format(value);
    }
    getPackageButtonText(packageItem: PackageModel): string {
        return packageItem.isCustomPrice ? 'Teklif Al' : 'Paketi Seç';
    }
    private configurePhoneValidator(): void {
        const phone = this.applicationForm.get('phone');
        phone?.clearValidators();
        phone?.setValue('');
        if (this.isCompany) {
            phone?.setValidators([
                Validators.required,
                Validators.pattern(/^[0-9+\s()\-]{10,20}$/)
            ]);
        }
        phone?.updateValueAndValidity({ emitEvent: false });
    }
    private passwordMatchValidator(control: AbstractControl): { passwordMismatch: true } | null {
        const password = control.get('password')?.value;
        const passwordRepeat = control.get('passwordRepeat')?.value;
        if (!password || !passwordRepeat)
            return null;
        return password === passwordRepeat
            ? null
            : { passwordMismatch: true };
    }
    private showRegisterError(message: string): void {
        this.stepStatus[2] = 'error';
        this.stepStatus[3] = 'pending';
        this.registerResult = 'error';
        this.registerErrorMessage = message || 'Kayıt işlemi tamamlanamadı.';
        this.currentStep = 2;
        this.scrollToWizard();
    }
    private scrollToWizard(): void {
        window.setTimeout(() => {
            document
                .querySelector('.wizard-roadmap')
                ?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
        });
    }
}
